import moment from "moment";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import IOnGetItemInOrdersReportDTO from "../../../../models/DTO/IOnGetItemInOrdersReportDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import { useAppContextNonNull } from "@contexts/AppContext";
import OwButton from "@components/shared/OwButton/OwButton";

type Props = {
    processedReport: IProcessed_Report;
};

export const ReportItemInOrders: React.FC<Props> = (props) => {
    const { uiContext } = useAppContextNonNull();
    const [reportData, setReportData] = useState<IOnGetItemInOrdersReportDTO>(props.processedReport.report_data);

    const exportToCsv = () => {
        if (!reportData) {
            return;
        }

        const rows = [["Order #", "Qty"]];

        for (const order of reportData.orders) {
            const row = [`${order.name}`, `${order.qty}`];

            rows.push(row);
        }

        rows.push([`Total Qty`, `${reportData.total}`]);

        const csvContent = rows.map((e) => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const selectedCatalogItem = ""; //selectedCatalogItem!.sku

        const fileName = `Item In Orders Report - ${selectedCatalogItem} - ${moment().format("YYYY-MM-DD")}.csv`;

        link.download = fileName;
        link.click();
    };

    return (
        <div className={"ReportItemInOrders"}>
            {uiContext.showHiddenFeatures && (
                <div>
                    <OwButton
                        fn={() => {
                            console.log(reportData);
                        }}
                        title={"Log Report Data"}
                    />
                </div>
            )}
            {!reportData ? null : (
                <div className="row mt-4">
                    <div className="col-12">
                        <OwLabel title={"export_to_csv"} fn={exportToCsv} />
                    </div>
                </div>
            )}
            <div>
                {!reportData ? (
                    <div className={"text-center"}>
                        <OwTitle leftIconName={"fad fa-chart-bar"} title={"no_report_loaded"} tag={"h3"} />
                    </div>
                ) : (
                    <div className={"mt-3 p-3"}>
                        <div className={"row"}>
                            <div className={"col-2"}>
                                <OwLabel title={"order"} isBold={true} isUnderline={true} />
                            </div>
                            <div className={"col-2 text-end"}>
                                <OwLabel title={"qty"} isBold={true} isUnderline={true} />
                            </div>
                        </div>
                        <div className={"row mb-3 mt-3"}>
                            <div className={"col-2"}>
                                <OwLabel title={"total_qty"} isBold={true} />
                            </div>
                            <div className={"col-2 text-end"}>
                                <b>{reportData.total}</b>
                            </div>
                        </div>
                        <div>
                            {reportData.orders.map((orderMapItem) => {
                                return (
                                    <div key={orderMapItem.guid} className={"row"}>
                                        <div className={"col-2"}>
                                            <Link to={`/orders/${orderMapItem.guid}/entry?checkout=false&view=line`} target={"_blank"}>
                                                {orderMapItem.name}
                                            </Link>
                                        </div>
                                        <div className={"col-2 text-end"}>{orderMapItem.qty}</div>
                                        <div className={"col-12 border-white"}>
                                            <hr className={"border-white"} />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
